'use client';

import { useGetAddressesQuery } from 'services/addressesApi';

import { Box, Flex } from '@chakra-ui/react';

import { useAppSelector } from 'store/hooks';

import { AddressDataInterface } from 'types';

import { ContentLoader } from '../../../ContentLoader';
import { ShipmentMethodItem } from '../ShipmentMethodItem';

interface ShipmentAddressListProps {
  onClick: (id: number) => void;
  onAddHandler: () => void;
  activeId?: number | null;
}
const ShipmentAddressList = ({
  onClick,
  onAddHandler,
  activeId
}: ShipmentAddressListProps) => {
  const { guestInfo } = useAppSelector((state) => state.persistGuestAuth);
  const { data: addresses = [], isLoading } = useGetAddressesQuery('', {
    refetchOnMountOrArgChange: true,
    skip: !!guestInfo
  });

  const getAddressInfo = (loc: AddressDataInterface): string[] =>
    [
      loc?.addr1 ?? '',
      loc?.addr2 ?? '',
      `${loc?.city ? `${loc?.city}, ` : ''}${loc?.state} ${loc?.postal}`
    ].filter((str) => Boolean(str));

  return isLoading ? (
    <Flex w='full' justifyContent='center'>
      <ContentLoader isLoading label='' minHeight='300px' />
    </Flex>
  ) : (
    <Flex
      gap='10px'
      flexWrap='wrap'
      justifyContent={addresses.length === 0 ? 'center' : 'flex-start'}
    >
      {addresses.map((location) => (
        <Box
          key={location?.addr_id}
          w={{
            base: '100%',
            md: 'calc(50% - 5px)'
          }}
        >
          <ShipmentMethodItem
            flex={1}
            h='full'
            label={location.addr_nickname}
            address={getAddressInfo(location)}
            onClick={() => onClick(location?.addr_id)}
            isActive={location?.addr_id === activeId}
          />
        </Box>
      ))}

      <Box
        w={{
          base: '100%',
          md: 'calc(50% - 5px)'
        }}
      >
        <ShipmentMethodItem
          minH={90}
          h='full'
          label='Add New Address'
          onClick={onAddHandler}
        />
      </Box>
    </Flex>
  );
};

export default ShipmentAddressList;
